<script>
import * as API from '../../api/endorses';
export default {
  name: 'EndorseActionButton',
  components: {
    CpButton: require('../../button').default,
    CpBaseSvgIcon: require('../../base-svg-icon').default,
    EndorseIcon: require('../../social-feed/icons/endorse').default,
    CpDialogAuthForm: require('../../auth-form/dialog-auth-form').default,
  },
  data() {
    return {
      currentlyEndorsed: this.endorsed,
      buttonClass: 'button--darkgray-outline',
      endorsedClass: 'endorsed',
      modalClass: 'btn-opacity',
      loading: false,
      showAuthModal: false,
    };
  },
  props: {
    onSuccess: Function,
    id: [String, Number],
    endorsed: [Boolean],
    type: String,
    modal: Boolean,
  },
  watch: {
    endorsed(newValue, oldValue) {
      if (newValue) {
        this.currentlyEndorsed = newValue;
      }
    },
  },
  computed: {
    authUser() {
      return this.$root.authUser;
    },
  },
  methods: {
    endorse() {
      if (!this.authUser) {
        this.showAuthModal = true;
      } else {
        this.handleEndorse();
      }
    },
    async handleEndorse() {
      this.loading = true;
        const data = {
          type: this.type,
          type_id: this.id,
          description: null,
          is_public: 1,
          vote: 'yes',
          source: this.type == 'crowdpac' ? this.type + '-detail' : 'candidate',
        };
        await API.vote(data)
          .then(response => {
            this.currentlyEndorsed = true;
            this.onSuccess('endorse');
          })
          .catch(error => {
            console.warn(error.toString());
          });

        this.loading = false;
    },
    handleCloseButton() {
      this.showAuthModal = false;
    },
  },
};
</script>

<template>
  <div>
    <cp-button
      :disabled="loading || currentlyEndorsed"
      darkgray-outline
      noborder
      bold
      @click="endorse"
      :class="[buttonClass, currentlyEndorsed ? endorsedClass : '', modal ? modalClass : '']"
    >
      <cp-base-svg-icon
        style="margin-top: 7px"
        :width="30"
        :height="30"
        viewBox="0 0 32 40"
        :icon-color="currentlyEndorsed ? 'var(--primary)' : 'var(--primary-blue-400)'"
        :stroke-color="'none'"
      >
        <endorse-icon />
      </cp-base-svg-icon>

      <span v-if="!$root.isMobile" :class="currentlyEndorsed ? 'body primary' : 'body primary-blue-400-color'">Endorse</span>
    </cp-button>
    <cp-dialog-auth-form v-if="showAuthModal" :handleCloseButton="handleCloseButton" showSignUp :callback-action="handleEndorse" />
  </div>
</template>

<style scoped>
.button--darkgray-outline {
  transition: color 0.2s ease;
}
.endorsed {
  color: var(--highlight);
}
.btn-opacity {
  opacity: initial !important;
}
</style>
